import type {ApolloError} from '@apollo/client';

/**
 * True when a query failed at the GraphQL/server level (the backend
 * rejected the operation outright, e.g. "Cannot query field ..." because
 * the field isn't deployed there yet) AND nothing came back to use. Does
 * NOT match a plain network failure (offline / timeout / 5xx) — those
 * keep their existing handling (cache, retry, the Offline indicator).
 *
 * ADDED 2026-09-30 (Duane): tankGaugeReading_AllWhere and
 * pulledBottom_AllWhere aren't supported by the backend yet. Features
 * built on them use this to switch themselves off quietly — the rest of
 * the app (Daily Report entry, Wells list, ...) must keep working
 * instead of failing along with them.
 */
export function isBackendUnsupportedQuery(error: ApolloError | undefined | null, hasData: boolean): boolean {
   if (!error || hasData) return false;
   if ((error.graphQLErrors?.length ?? 0) > 0) return true;
   const statusCode = (error.networkError as {statusCode?: number} | null | undefined)?.statusCode;
   return statusCode === 400;
}
